import { isRSAA, RSAA } from 'redux-api-middleware';

const headersMiddleware = () => next => action => {
  if (!isRSAA(action)) {
    return next(action);
  }

  return next({
    ...action,
    [RSAA]: {
      ...action[RSAA],
      headers: {
        ...action[RSAA].headers,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }
  });
};

export default headersMiddleware;
